<template>
 
<ui-button-options v-on:click.native.stop="viewItem()" :title="title">
      <div slot="left"><img @error="imgLoadError" v-if="imageUrl" class="img-icon" :src="imageUrl"></div>
      <div slot="options" v-if="computeUserAccess">
        <ui-option title="language.edit" v-on:click.native.stop.prevent="editItem()" backgroundColor="#F2BC55" color="#FFFFFF" icon="pencil-alt"/>
        <ui-option title="language.delete" v-on:click.native.stop.prevent="deleteItem()" backgroundColor="#F46767" color="#FFFFFF" icon="times"/>
      </div>
   </ui-button-options>
</template>

<script>
import UiButtonOptions from '../UiButtonOptions.vue';
import UiOption from '../UiOption.vue';
import { USER_LEVEL } from '../../settings/USER_LEVEL.js';
import { mapState } from 'vuex';

export default {
  name: 'button-album',
  props:{
    title:{default:"no-title"},
    imageUrl:{default:"no-url"},
    item_id:undefined,
    group_id:undefined,
  },
  data:function(){
    return {
    }
  },
  computed:{
    ...mapState([
       'appSettings','group'
      ]),
    computeUserAccess(){
        var isInGlobal=(this.$router.currentRoute.path=='/albums');
        if(!this.group.authorized && !isInGlobal ){
            // if we are in a group
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.NONE){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }
         return false;
       }
  },
  methods:{
    editItem(){
      this.$router.push({path:'/group/'+this.group_id+'/photoalbum/'+this.item_id+'/update/'})
    },
    deleteItem(){

      var isInGlobal=(this.$router.currentRoute.path=='/albums');

      var payload={
        id:this.item_id,
        store_key:isInGlobal ? "0album" : this.group.id+"album", // serves as a key for store array (cal_id 0 is global)
      }
      this.$store.dispatch('delete_album',payload);
    },
    viewItem(){
      this.$router.push({path:'/photoalbum/'+this.item_id+'/view'});
    },
    imgLoadError(event){
      event.target.src=require('../../assets/thumb_404.png');
    },
  },
  mounted:function(){
    
  },
  components:{
    UiButtonOptions,
    UiOption
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.img-icon{
  display:block;
  height: 50px;
  width: 50px;
  border-radius: 9999px;
  border: 1px solid #707070;
}
</style>
